export default __webpack_public_path__ + "static/media/cf.e2e89fb8.svg";